import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgMoreSelectedNavIconSecondary(props) {
  return jsx("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M10.35 4.708a2.357 2.357 0 0 0 2.35-2.354A2.357 2.357 0 0 0 10.35 0 2.357 2.357 0 0 0 8 2.354a2.357 2.357 0 0 0 2.35 2.354ZM10.35 7.65A2.35 2.35 0 0 0 8 10.006a2.35 2.35 0 0 0 2.35 2.354 2.357 2.357 0 0 0 2.35-2.354 2.357 2.357 0 0 0-2.35-2.354ZM10.35 15.292A2.357 2.357 0 0 0 8 17.646 2.357 2.357 0 0 0 10.35 20a2.357 2.357 0 0 0 2.35-2.354 2.357 2.357 0 0 0-2.35-2.354Z",
    fill: "currentColor"
  }));
}

export { SvgMoreSelectedNavIconSecondary as default };
